<mat-toolbar class="subtitulo">Reunioes</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultarReuniao="ngForm">
            <div fxLayout="row" fxFlexFill>                
                <div ngModelGroup="comboReuniao" fxFlex="100">
                    <combo-reuniao  [showDisplayId]="false"
                                    [obrigatorio]="false"
                                    [selecionado]="temaSelecionado"
                                    [label]="'Tema da Reunião'"
                                    [campoPesquisavel]="'tema'"
                                    (valorChange)="onTemaChangeReuniao($event)">
                    </combo-reuniao>
                </div>
            </div>
            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboReuniao" fxFlex="100">
                    <combo-reuniao [showDisplayId]="false"
                                    [obrigatorio]="false"
                                    [selecionado]="localSelecionado"
                                    [label]="'Local'"
                                    [campoPesquisavel]="'local'"
                                    (valorChange)="onLocalChangeReuniao($event)">
                    </combo-reuniao>
                </div>
            </div>
            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboParticipacao" fxFlex="100">
                    <combo-pesquisa-participante-reuniao [showDisplayId]="false"
                                    [obrigatorio]="false"
                                    [selecionado]="participanteSelecionado"
                                    [label]="'Participante'"
                                    [campoPesquisavel]="'nome'"
                                    (valorChange)="onNomeParticipanteChangeReuniao($event)"
                                    >
                    </combo-pesquisa-participante-reuniao>
                </div>
                
                <div ngModelGroup="comboPessoaFisica" fxFlex="100">
                    <combo-pessoa-fisica
                            [label]="'Relator'"
                            [showDisplayId]="false" 
                            [obrigatorio]="false"
                            [selecionado]="relatorSelecionado"
                            (valorChange)="onNomeChangeRelatorReuniao($event)">
                    </combo-pessoa-fisica>
                </div>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="10">
                    <mat-label>Data Início</mat-label>
                    <input matInput name="dataInicioVigencia" [matDatepicker]="dataInicioPicker" placeholder="Data Início"
                           [(ngModel)]="dataInicioVigencia" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioPicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="10">
                    <mat-label>Data Fim</mat-label>
                    <input matInput name="dataFimVigencia" [matDatepicker]="dataFimPicker" placeholder="Data Fim"
                           [(ngModel)]="dataFimVigencia" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimPicker></mat-datepicker>
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                 fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">


          <ng-container matColumnDef="tema">
            <th mat-header-cell *matHeaderCellDef> Tema: </th>
            <td mat-cell *matCellDef="let element"> {{element.tema}} </td>
          </ng-container>

          <ng-container matColumnDef="local">
            <th mat-header-cell *matHeaderCellDef> Local: </th>
            <td mat-cell *matCellDef="let element"> {{element.local}} </td>
          </ng-container>

          <ng-container matColumnDef="relator">
            <th mat-header-cell *matHeaderCellDef> Relator: </th>
            <td mat-cell *matCellDef="let element"> {{element.relator.nome}} </td>
          </ng-container>

          <ng-container matColumnDef="dataInicio">
            <th mat-header-cell *matHeaderCellDef> Data:  </th>
            <td mat-cell *matCellDef="let element"> {{element.dataInicio | dataSimples}} </td>
          </ng-container>

          <ng-container matColumnDef="participantes">
            <th mat-header-cell *matHeaderCellDef> Qtd Participantes:  </th>
            <td mat-cell *matCellDef="let element"> {{element.participantes.length}} </td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef> Ações </th>
            <td mat-cell *matCellDef="let element">
                <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                    <mat-icon>delete</mat-icon>
                </button>
                <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                    <mat-icon>{{ perfilAcesso.altera ? 'edit' : 'search' }}</mat-icon>
                </button>
            </td>
        </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova reuniao" mat-fab color="primary"
                    [routerLink]="menu ? ['/', menu, 'reunioes', 'cadastrar'] : ['/reunioes', 'cadastrar']"
                    routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

